// Shared, non-judgmental dimension visualization. No evaluative categories or scores.
const DIM_COLOR = {
  self_relationship: "#D9A25F",
  external_validation: "#C46243",
  fear_uncertainty: "#8A99AD",
  scaffolding: "#4A6B6C",
  intentional_practice: "#7D9D86",
  future_orientation: "#B8860B",
  joy_freedom_play: "#E69A45",
};

export const DimensionBar = ({ dimKey, name, aligned, max = 5, testId }) => {
  const pct = Math.max(4, Math.min(100, (aligned / max) * 100));
  const color = DIM_COLOR[dimKey] || "#D9A25F";
  return (
    <div className="py-3" data-testid={testId}>
      <div className="flex items-baseline justify-between mb-2">
        <span className="text-sm text-[#F3F4F6] font-medium">{name}</span>
      </div>
      <div className="h-2 rounded-full bg-[#222634] overflow-hidden">
        <div className="h-full rounded-full transition-all duration-700"
             style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
    </div>
  );
};

export { DIM_COLOR };
